module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAMFBMVEUAAABmdX9mdX9mdX9mdX+foJT/6LZVrO5mdX+pm2n/zE3/zE3BaU+8vsC8vsC8vsC2hV0fAAAAEHRSTlMAj/8An////4D//wD/gP8AHgs1EQAAANVJREFUeAHt0MENgjAchfE3AxvQaKJnnUA38OAG/Ffw7giOwQqu4AxuICvUlgM1fFL1YkLSlwAJ+fIjVLNYVW/G0/jF1rn9x2jn3AIRIVIiREqAlgdQAnRsQAmQGSgBMgMlQqREiJQIkRIhUiJESoRIiRApESIlQqREiJQIkRIhUiJESoRIiRApESIlQqT6qAI0UPUQEUpUiiJ0CrPRo3mJzmt7H9lllf6unYraa5z6+6wjrkQ2fZi3sMyJlyguRTzMEt27zB7ee4Wry+6X6KvP5ff/6AkaB2VcYHSZ/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3e0.png
// module id = 808
// module chunks = 0